/** UI copy for the app frame and app-level pages. Shared labels live in `COMMON_TEXT`. */
export const APP_TEXT = {
  layout: {
    idleTitle: 'Still there?',
    signOut: 'Sign out',
    signOutTitle: 'Sign out?',
    signOutMessage: "You'll need to sign in again to use Compliance Desk.",
    signedOut: 'Signed out successfully.',
    staySignedIn: 'Stay signed in',
    idleMessage: "You've been inactive for a while. For security you'll be signed out in one minute.",
    showSidebar: 'Show sidebar',
  },
  notFound: {
    title: 'Page not found',
    message: 'The page you opened does not exist or has moved.',
    backToDashboard: 'Back to Dashboard',
  },
  placeholder: {
    comingSoon: 'Coming soon',
    phase: (phase: number) => `This screen is built in Phase ${phase} of the roadmap.`,
    notBuilt: 'This screen is not built yet.',
  },
  routeError: {
    unexpected: 'Unexpected error',
    title: 'Something went wrong on this screen',
    updatedTitle: 'A new version of the app is available',
    updatedMessage: 'Reload the page to continue.',
    reload: 'Reload',
  },
} as const;
